<template>
  <v-app>
    <div id="app" v-if="$route.meta.layout" class="grid grid-cols-[auto_1fr] w-full h-screen">
      <!-- Sidebar -->
      <SideBar :routes="getRoutes" class="h-screen" />

      <!-- Conteúdo -->
      <div class="bg-slate-100 flex flex-col overflow-x-hidden">
        <div class="px-5 py-2 flex-auto overflow-y-auto">
          <router-view :key="$route.fullPath" />
        </div>
      </div>

      <!-- Custom Cursor -->
      <div v-if="showChickenCursor" class="chicken-cursor" :style="{ left: x + 'px', top: y + 'px' }">
        <img :src="getChickenGif()" alt="cursor" />

      </div>
    </div>

    <div v-else>
      <router-view :key="$route.fullPath" />
    </div>
  </v-app>
</template>

<script>
import SideBar from '@/components/layout/SideBar.vue';
import { mapGetters } from 'vuex';

export default {
  components: { SideBar },
  computed: {
    ...mapGetters('interface', ['getRoutes']),
  },
  data() {
    return {
      showChickenCursor: false,
      x: 0,
      y: 0,
      chickenState: "static",
      chickenColor: "white",
      movementTimeout: null,
    };
  },
  created() {
    this.$root.$on("enable-chicken-cursor", () => {
      this.toggleChickenCursor();
    });
  },
  methods: {
    getChickenGif() {
      return require(`@/assets/chicken/${this.chickenColor}/${this.chickenState}.gif`);
    },
    toggleChickenCursor() {
      this.showChickenCursor = !this.showChickenCursor;
      document.body.style.cursor = this.showChickenCursor ? "none" : "auto";

      if (this.showChickenCursor) {
        if (this.chickenColor === "white") {
          this.chickenColor = "black";
        } else {
          this.chickenColor = "white";
        }
        document.body.classList.add("hide-default-cursor");
        window.addEventListener("mousemove", this.updateCursor);
        window.addEventListener("mousedown", this.onMouseDown);
        window.addEventListener("mouseup", this.onMouseUp);
      } else {
        document.body.classList.remove("hide-default-cursor");
        window.removeEventListener("mousemove", this.updateCursor);
        window.removeEventListener("mousedown", this.onMouseDown);
        window.removeEventListener("mouseup", this.onMouseUp);
      }
    },
    updateCursor(e) {
      this.x = e.clientX;
      this.y = e.clientY;

      this.chickenState = "walk";

      clearTimeout(this.movementTimeout);
      this.movementTimeout = setTimeout(() => {
        this.chickenState = "static";
      }, 200);
    },
    onMouseDown() {
      this.chickenState = "peck";
    },
    onMouseUp() {
      this.chickenState = "static";
    },
  },
  beforeUnmount() {
    window.removeEventListener("mousemove", this.updateCursor);
    window.removeEventListener("mousedown", this.onMouseDown);
    window.removeEventListener("mouseup", this.onMouseUp);
    document.body.style.cursor = "auto";
  },
};
</script>

<style lang="scss">
@use '@/assets/styles/tooltip.scss';

.chicken-cursor {
  position: fixed;
  pointer-events: none;
  transform: translate(-50%, -50%);
  z-index: 99999;
}

.chicken-cursor img {
  width: 40px;
  height: 40px;
}

.hide-default-cursor * {
  cursor: none !important;
}
</style>
